module.exports = __webpack_public_path__ + "img/pic-icon.e8ce4a52.svg";